module.exports = __webpack_public_path__ + "static/media/Autolinker.9747843f.woff";